<mat-accordion displayMode="flat">
  <mat-expansion-panel togglePosition="before" class="expansion-panel">
    <mat-expansion-panel-header collapsedHeight="56px" expandedHeight="56px" class="expansion-panel-header">
      <div class="panel-title-container">
        <mat-panel-title class="panel-title">{{ knowledgeName() }}</mat-panel-title>
        <mat-panel-description>
          <span class="panel-description">{{ panelDescription() }}</span>
        </mat-panel-description>
      </div>
      <button mat-icon-button class="remove-button" (click)="remove.emit()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-expansion-panel-header>
    @switch (type()) {
      @case (KnowledgeSourceConfigType.KNOWLEDGE_SOURCE_CONFIG_TYPE_BUSINESS_PROFILE) {
        <ng-container *ngTemplateOutlet="businessProfile"></ng-container>
      }
      @case (KnowledgeSourceConfigType.KNOWLEDGE_SOURCE_CONFIG_TYPE_CUSTOM_DATA) {
        <ng-container *ngTemplateOutlet="customData"></ng-container>
      }
      @case (KnowledgeSourceConfigType.KNOWLEDGE_SOURCE_CONFIG_TYPE_WEBSITE_SCRAPE) {
        <ng-container *ngTemplateOutlet="website"></ng-container>
      }
    }
  </mat-expansion-panel>
</mat-accordion>

<ng-template #businessProfile>
  <p class="gray-card-label">{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.ASSOCIATED_PROFILE' | translate }}</p>
  <mat-card class="gray-card-card">
    <mat-card-content class="gray-card">
      <p class="gray-card-name">{{ accountGroupNameResource.value() }}</p>
      <a class="gray-card-button" href="{{ businessProfileUrl() }}">
        {{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.MANAGE_PROFILE' | translate }}
      </a>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #customData>
  <ng-container [formGroup]="form()">
    <glxy-form-field>
      <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.NAME' | translate }}</glxy-label>
      <input type="text" matInput formControlName="name" />
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.CONTENT' | translate }}</glxy-label>
      <glxy-label-hint>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.CONTENT_HINT' | translate }}</glxy-label-hint>
      <textarea
        matInput
        formControlName="content"
        cdkTextareaAutosize
        cdkAutosizeMinRows="20"
        cdkAutosizeMaxRows="60"
      ></textarea>
    </glxy-form-field>
  </ng-container>
</ng-template>

<ng-template #website>
  @if (refreshingKnowledge()) {
    <glxy-empty-state class="ai-knowledge-spinner-container">
      <glxy-empty-state-hero>
        <ai-knowledge-loading-spinner class="ai-knowledge-spinner" />
      </glxy-empty-state-hero>
      <glxy-empty-state-title> {{ refreshingTitle() }}</glxy-empty-state-title>
      <p>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.FEW_MINUTES' | translate }}</p>
    </glxy-empty-state>
  } @else {
    <ng-container [formGroup]="form()">
      <glxy-form-field>
        <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.NAME' | translate }}</glxy-label>
        <input type="text" matInput formControlName="name" />
      </glxy-form-field>
      <glxy-form-field>
        <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.URL' | translate }}</glxy-label>
        <input type="text" matInput formControlName="url" />
      </glxy-form-field>
      <glxy-form-field>
        <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.MODE' | translate }}</glxy-label>
        <mat-select formControlName="crawlMode">
          @for (mode of modeOptions; track mode) {
            <mat-option [value]="mode.value">{{ mode.label | translate }}</mat-option>
          }
        </mat-select>
      </glxy-form-field>
    </ng-container>

    <p class="gray-card-label">{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.LAST_REFRESHED' | translate }}</p>
    <mat-card class="gray-card-card">
      <mat-card-content class="gray-card">
        <p class="gray-card-name">{{ lastRefreshed() | date: 'MMM d, y, h:mm a' }}</p>
        <div class="gray-card-buttons">
          <a class="gray-card-button" (click)="openKnowledgeWebPagesDialog()">
            <mat-icon>description</mat-icon>
            {{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.WEB_PAGES' | translate }}
          </a>
          <a class="gray-card-button" (click)="rescrape()">
            <mat-icon>refresh</mat-icon>
            {{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.REFRESH' | translate }}
          </a>
        </div>
      </mat-card-content>
    </mat-card>
  }
</ng-template>
